/** Magic bytes for allowed image upload formats. */
export const IMAGE_SIGNATURES: Record<string, number[]> = {
    'image/jpeg': [0xFF, 0xD8, 0xFF],
    'image/png': [0x89, 0x50, 0x4E, 0x47],
    'image/gif': [0x47, 0x49, 0x46, 0x38],
    'image/webp': [0x52, 0x49, 0x46, 0x46], // RIFF header (WebP starts with RIFF...WEBP)
};

/** Validate that a file's first bytes match its declared MIME type. */
export async function validateMagicBytes(file: File): Promise<boolean> {
    const sig = IMAGE_SIGNATURES[file.type];
    if (!sig) return false;
    const buffer = await file.slice(0, 8).arrayBuffer();
    const bytes = new Uint8Array(buffer);
    return sig.every((b, i) => bytes[i] === b);
}

/** Rewrite a Supabase public URL to use the edge image transformation endpoint. */
export function withTransform(
    publicUrl: string,
    opts: { width?: number; height?: number; quality?: number; resize?: 'cover' | 'contain' | 'fill' },
): string {
    if (!publicUrl || !publicUrl.includes('/storage/v1/object/public/')) return publicUrl;
    const url = new URL(publicUrl);
    url.pathname = url.pathname.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/');
    if (opts.width) url.searchParams.set('width', String(opts.width));
    if (opts.height) url.searchParams.set('height', String(opts.height));
    if (opts.quality) url.searchParams.set('quality', String(opts.quality));
    if (opts.resize) url.searchParams.set('resize', opts.resize);
    return url.toString();
}
